import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {Button} from "primeng/button";
import {ButtonGroup} from "primeng/buttongroup";
import {PrimeTemplate} from "primeng/api";
import {ReactiveFormsModule} from "@angular/forms";
import {TableModule} from "primeng/table";
import {Tag} from "primeng/tag";
import {EmailDto} from "admin-api-dto";
import {EmailService} from "../../../services/email.service";
import {AsyncPipe, DatePipe} from "@angular/common";

@Component({
  selector: 'app-emails-tab',
  standalone: true,
  imports: [
    Button,
    ButtonGroup,
    PrimeTemplate,
    ReactiveFormsModule,
    TableModule,
    Tag,
    AsyncPipe,
    DatePipe
  ],
  templateUrl: './emails-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailsTabComponent {
  protected readonly emails$ = this.emailService.emails$;
  constructor(private readonly emailService: EmailService) {
  }

  public downloadEmail(
    s3Key: string,
  ) {
    this.emailService.openEmail(s3Key);
  }
}
